<div class="background-content">
    <h2>Componente Bloqueado</h2>
    <p>Este Conteúdo está bloqueado</p>
    <div class="card-container mt-3 d-flex flex-wrap gap-3">
        <div class="card w-100 m-2 p-3">
            <h5 class="card-title">Card 1</h5>
            <p class="card-text">Descrição do Card 1.</p>
        </div>

        <div class="card w-100 m-2 p-3">
            <h5 class="card-title">Card 2</h5>
            <p class="card-text">Descrição do Card 2.</p>
        </div>
        
        <div class="card w-100 m-2 p-3">
            <h5 class="card-title">Card 3</h5>
            <p class="card-text">Descrição do Card 3.</p>
        </div>
    </div>
</div>

<div class="locked-overlay d-flex flex-column align-items-center justify-content-center">
    <div class="locked-content text-center">
        <div class="locked-icon mb-3">
            <lord-icon src="https://cdn.lordicon.com/drdlomqk.json" trigger="loop"
            colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px" delay="4000"></lord-icon>
        </div>
        <h4 class="locked-title">{{ 't-feature-locked' | translate }}</h4>
        <p class="locked-message">{{ 't-upgrade-plan-message' | translate }}</p>
    </div>
</div>